<template>
<div id="addAutoTagsModal" class="modal" v-if="showAddAutoTagsPopup">
    <div class="modal-content" @click.stop="" style="height:auto;">
        <div class="my-modal-header" v-show="isViewerLoaded && isGeometryLoaded && !showProgress">
            <div style="font-weight: bold;font-size: 22px;">Automatic Tag Harvester</div>
            <span class="close" @click="onCloseClicked()"></span>
        </div>
        <div class="modal-body" style="padding: 0px;max-height: 690px;" v-show="isViewerLoaded && isGeometryLoaded && !showProgress">

            <div class="tag-harvester-main-info-section">
                <div style="flex:7.5;">
                    <span class="harvester-input-title">Title</span>
                    <div>
                        <input type="text" style="width: 100%;height: 30px;" v-model="tagHarvester.title" :disabled="isReadOnly"/>
                    </div>
                </div>
                
                <div style="flex:3;">
                    <span class="harvester-input-title">Tier Level</span>
                    <div class="tiers-options">
                        <input v-if="isReadOnly" style="width: 100%;height: 30px;" type="text" :value="tagHarvester.selectedTreeLevel" disabled/>
                        <select v-else v-model="tagHarvester.selectedTreeLevel" style="width: 100%;">
                            <option v-for="lev in treeLevels" :key="lev">{{lev}}</option>
                        </select>
                    </div>
                </div>
                <div class="add-option-button option-action" v-if="!isReadOnly">
                    <i class="fas fa-plus" v-if="!tagHarvester.filterOptions.length && !isReadOnly" @click="addNewOption"></i>
                </div>
            </div>

            <div class="options-title d-flex" v-if="!!tagHarvester.filterOptions.length">
                <span class="" style="flex:1;">Operator</span>
                <span style="flex:2.5;">Category</span>
                <span style="flex:2;">Property</span>
                <span style="flex:2;">Condition</span>
                <span style="flex:3.1;">Value</span>
                <span style="width:12.5px;" v-if="!isReadOnly"></span>
            </div>
            <div class="option-row" v-for="(option, index) in tagHarvester.filterOptions" :key="index">
                <div class="" style="flex:1;">
                    <input v-if="isReadOnly" type="text" :value="option.operation" disabled/>
                    <select v-else v-model="option.operation">
                        <option v-for="op in operations" :key="op">{{ op }}</option>
                    </select>
                </div>
                <div style="flex:2.5;">
                    <input v-if="isReadOnly" type="text" :value="option.category" disabled/>
                    <select v-else v-model="option.category">
                        <option v-for="category in Object.keys(propertiesByCategory)" :key="category">{{ category }}</option>
                    </select>
                </div>
                <div style="flex:2;">
                    <input v-if="isReadOnly || !option.category" type="text" :value="option.property" disabled/>
                    <select v-else v-model="option.property">
                        <option v-for="property in propertiesByCategory[option.category] ?  propertiesByCategory[option.category] : []" :key="property">{{ property }}</option>
                    </select>
                </div>
                <div style="flex:2;">
                    <input v-if="isReadOnly" type="text" :value="option.condition" disabled/>
                    <select v-else v-model="option.condition">
                        <option v-for="condition in conditions" :key="condition">{{ condition }}</option>
                    </select>
                </div>
                <div style="flex:3.1;">
                    <input v-if="option.condition == 'Is Not Empty'" type="text" value="" :disabled="true"/>
                    <div class="input-with-icon" v-else>
                        <input v-virtual-keyboard type="text" v-model="option.value" :disabled="isReadOnly"/>
                        <i title="Case Sensitive" :class="['fas', option.caseSensitive ? 'fa-lock' : 'fa-lock-open']" @click="toggleCaseSensitive(option)"></i>
                    </div>
                </div>
                <div class="option-action" v-if="!isReadOnly">
                    <i class="fas fa-plus" v-if="index == tagHarvester.filterOptions.length - 1 && tagHarvester.filterOptions.length < 5" @click="addNewOption"></i>
                    <i class="fas fa-trash" @click="removeOption(index)"></i>
                </div>
            </div>
            <div class="row-input harvester-search-section" style="justify-content:flex-start;column-gap:10px">
                <div style="flex:2;">
                    <span class="harvester-input-title">Search against the Master</span>
                    <div class="tiers-options">
                        <input v-if="isReadOnly" style="width: 100%;height: 30px;" type="text" :value="tagHarvester.masterType" disabled/>
                        <select v-else v-model="tagHarvester.masterType" style="width: 100%;">
                            <option v-for="type in masterTypes" :key="type">{{`${type} Master`}}</option>
                        </select>
                    </div>
                </div>
                <div class="harvester-result-text" style="flex:2;">
                    <div>{{ validNodesLength }} New tags to be created</div>
                    <div style="color:red;">{{ invalidIdsCount }} Duplicated tags ignored</div>
                </div>
                <div class="result-options" style="flex:3;">
                    <div class="flex-center">
                        <input type="checkbox" style="height: 14px;" v-model="removeSlash" id="removeSlashInput" @change="updateTagsNames()"/>
                        <label for="removeSlashInput" style="flex-grow:1;">Remove leading “/” from the each tag</label>
                    </div>
                    <div class="flex-center">
                        <input type="checkbox" style="height: 14px;" v-model="tagHarvester.markIgnore" id="markIgnore" @change="updateIgnoredTags($event)"/>
                        <label for="markIgnore" style="flex-grow:1;">Mark found element as "Ignore"</label>
                    </div>
                </div>
                <div class="admin-btn" :class="{'disabled': searchDisabled}" style="flex:1.3;" @click="updateTags()">{{isReadOnly ? "UPDATE" : "SEARCH"}}</div>
            </div>
            <div class="matching-property-container">
                <div>
                    <span>Category</span>
                    <input v-if="isReadOnly" type="text" :value="matchingCategory" disabled/>
                    <select v-else v-model="matchingCategory">
                        <option v-for="category in Object.keys(propertiesByCategory)" :key="`matching-${category}`">{{ category }}</option>
                    </select>
                </div>
                <div>
                    <span>Property</span>
                    <input v-if="isReadOnly" type="text" :value="matchingProperty" disabled/>
                    <select v-else v-model="matchingProperty">
                        <option v-for="property in propertiesByCategory[matchingCategory] ?  propertiesByCategory[matchingCategory] : []" :key="`matching-${property}`">{{ property }}</option>
                    </select>
                </div>
            </div>
            <div>
                <hr>
                <div class="d-flex" style="min-height:370px;">
                    <div style="display:flex;flex-direction:column;width: 44%;">
                        <div class="row-input" style="height: 40px;">
                            <span>Preview</span>
                            <div class="search-input-bar">
                                <div class="remove-border fas fa-search"></div>
                                <input type="text" v-virtual-keyboard class="search-bar" placeholder="Search (min 3 character) ..." v-model="input" />
                                <button @click="clearFilter" class="fas fa-times cursor-pointer remove-border"></button>
                            </div>
                        </div>
                        <div v-if="!!shownTagsList.length" id="harvester_scrollable" class="scrollable-content" style="display:flex;flex-direction:column;" @scroll="onScroll($event)">
                            <ForgeCard v-for="(element, index) in shownTagsList"
                                        :id="`equipment-${element.id}`"
                                        :key="`harvester-card-${index}-${element.id}`"
                                        :is_highlighted="element.id == selectedHarvesterNodeId"
                                        style="width:98%;" 
                                        :selectable="element"
                                        :title="element.name"
                                        :category="element.category"
                                        :watermark="'Equipment'"
                                        :watermark_color="element.getWatermarkColor()"
                                        :url=tagHoverSrc
                                        :showcheckbox="false"
                                        :bottomtext="element.matchedSearch"
                                        @on-card-clicked="zoomToTag(element)"
                            ></ForgeCard>
                        </div>
                        <div v-else class="none-tags">
                            <div>
                                <span>NONE</span>
                            </div>
                        </div>
                        <div class="modal-footer" style="margin-right:8px;" v-if="isGeometryLoaded && !showProgress">
                            <div class="admin-btn admin-btn-secondary" style="width: 50%;" @click="onCloseClicked()">Cancel</div>
                            <div :class="['admin-btn', generateDisabled ? 'disabled' : '']" style="width: 50%;" @click="generate()">
                                <span v-if="!disabledIgnoreButton && !shownTagsList.length">Continue</span>
                                <span v-else>Check Master</span>
                            </div>
                        </div>
                    </div>
                    <div style="width: 54%;" class="pl-10">
                        <div class="row-input" style="height:40px;padding-right:0;">
                            <span>Model Tree</span>
                            <!-- <div v-if="tagHarvester.markIgnore" style="display:flex;justify-content:space-between;align-items:center;column-gap:30px;">
                                <button class="rounded-btn" :disabled="disabledIgnoreButton" @click="saveIgnoredTags()">Save Ignored</button>
                            </div> -->
                            <div class="filters-buttons">
                                <button class="filter-button filtered-tag-image" :class="{'selected-category' : selectedCategories.includes('filtered-tag')}" @click="toggleCategory('filtered-tag')" title="Filtered tags" ></button>
                                <button class="filter-button created-tag-image" :class="{'selected-category' : selectedCategories.includes('created-tag')}" @click="toggleCategory('created-tag')" title="Created tags" ></button>
                                <button class="filter-button available-tag-image" :class="{'selected-category' : selectedCategories.includes('available-tag')}" @click="toggleCategory('available-tag')" title="Available tags" ></button>
                                <button class="filter-button ignored-tag-image" :class="{'selected-category' : selectedCategories.includes('ignored-tag')}" @contextmenu="openContextMenu" @click="toggleCategory('ignored-tag')" title="Ignored tags" ></button>
                            </div>
                        </div>
                        <div>
                            <TagHarvesterPreview v-if="isGeometryLoaded"></TagHarvesterPreview>
                            <div v-else class="spinning-container">
                                <div class="fas fa-spinner spinning"></div>
                            </div>
                        </div>
                    </div>
                </div>               
            </div>
        </div>
        <HarvesterTagsResult v-if="showTagMasterResult" @close="onCloseClicked"></HarvesterTagsResult>
        <LoadingPopup v-if="!isViewerLoaded || !isGeometryLoaded || showProgress" :show="true" :text="progressText" style="position: relative;"></LoadingPopup>
        <ContextMenu ref="menu">
			<ul>
				<li @click="clearAllIgnored"><i class="fas fa-trash"></i> Clear ignored nodes</li>
			</ul>
		</ContextMenu>
    </div>
</div>
</template>

<script>
/* eslint-disable no-unused-vars, vue/no-unused-components */
import tagHoverImage from '../../../images/tagHover.png'
import { postDataAsync } from '@/utils/mongoUtils'
import { getNodeChildDbids, isolateForge, scrollToElementInContainer, getBBBox, getMiddleBBoxForGroup } from '@/utils/forgeUtils'
import { groupBy } from '@/scripts/js/forgeService'
import { ForgeEquipment, ForgeObject } from '@/scripts/js/forgeModels'
import $ from 'jquery'
import HttpService from '../../../utils/httpService'
export default {
    name: 'AddAutomaticTagsPopup',
    components: {
        ForgeCard: () => import('@/components/common/forgeCard.vue'),
        TagHarvesterPreview: () => import('@/components/admin/components/tag-harvester-preview/tag-harvester-preview.vue'),
        LoadingPopup: () => import('@/components/common/loadingPopup.vue'),
        ContextMenu: () => import('@/components/common/context-menu.vue'),
        HarvesterTagsResult: () => import('@/components/admin/popups/harvesterTagResult/harvesterTagsResult.vue'),
    },
    data() {
        return {
            timeout: null,
            treeLevels: [],
            masterTypes: ['Equipment', 'Pipeline', 'Structural'],
            operations: ['And', 'Or', 'Not'],
            conditions: ['Contains', 'Equals', 'Is Not Empty', 'Starts with'],
            tagsToCreate: [],
            tagHoverSrc: tagHoverImage,
            shownTagsLength: 40,
            shownTagsStartIndex: 0,
            showProgress: false,
            progressText: '',
            invalidIdsCount: 0,
            showResult: true,
            removeSlash: false,
            searchInput: "",
            currentSearchText: "",
            shownTagsList: [],
        }
    },
    methods: {
        initializeComponent() {
            this.$store.commit('SET_MUTABLE_IGNORED_TAGS_IDS', [...this.$store.getters['GET_IGNORED_TAGS_IDS']]);

            if (!this.viewer || !this.viewer.model) {
                console.log(`❌ Viewer or Model is not loaded.`);
                return;
            }
            
            let instanceTree = this.viewer.model.getInstanceTree();

            if (!instanceTree) {
                console.log(`❌ Instance Tree is not loaded.`)
                return;
            }

            let levels = ["All Tiers"];
            for (let i = 1; i <= instanceTree.maxDepth; i++) levels.push(`Tier ${i}`);
            this.treeLevels = levels;
        },
        toggleCaseSensitive(option) {
            if (this.isReadOnly) return;

            option.caseSensitive = !option.caseSensitive;
        },
        openContextMenu(e) {
			e.preventDefault();
			this.$refs.menu?.open(e);
		},
        clearAllIgnored() {
            this.$store.dispatch({
                type: "confirm_Forge",
                message: 'Are you sure you want to clear ignored tags?', callback: () => {
                    this.$store.commit('SET_MUTABLE_IGNORED_TAGS_IDS', []);
                }
            })
			this.$refs.menu?.close();
        },
        updateIgnoredTags(e) {
            let ignoredTags = this.$store.getters['GET_MUTABLE_IGNORED_TAGS_IDS'];
            let tagsDbIds = this.validNodes.map(n => n.dbId);

            if (this.tagHarvester.markIgnore) {
                this.$store.commit('SET_MUTABLE_IGNORED_TAGS_IDS', [...ignoredTags, ...tagsDbIds]);
            } else {
                this.$store.commit('SET_MUTABLE_IGNORED_TAGS_IDS', ignoredTags.filter(t => !tagsDbIds.includes(t)));
            }
        },
        saveIgnoredTags() {
            let ignoredIds = this.$store.getters['GET_MUTABLE_IGNORED_TAGS_IDS'];

            postDataAsync(`api/equipments/updateIgnoredDbIds`, 
            { assetId: this.$store.state.assetId, ignoredDbIds: ignoredIds.join(',') }, 
            (_) => {
                this.$store.commit('SET_IGNORED_TAGS_IDS', ignoredIds);
            })
        },
        getNodesAtDepth(rootId, instanceTree, depth) {
            console.log(`⚠️ Get Nodes at Depth: ${depth}`)
            const nodes = [];
            function traverse(nodeId, currentDepth) {
                if (depth == 0 || currentDepth === depth) {
                    nodes.push(nodeId);
                } 

                if (depth == 0 || currentDepth < depth) {
                    let children = getNodeChildDbids(nodeId, instanceTree)
                    children.forEach(child => traverse(child, currentDepth + 1));
                }
            }
            traverse(rootId, 0);
            console.log(`✅ Nodes at Depth: ${depth} - ${nodes.length}`)
            return nodes;
        },
        addNewOption() {
            this.tagHarvester.filterOptions.push({ operation: 'And', category: '', property: '', condition: '', value: '', caseSensitive: false })
        },
        removeOption(index) {
            this.tagHarvester.filterOptions.splice(index, 1);
        },
        isValidValue(condition, value, input, caseSensitive = false) {
            if (condition === 'Is Not Empty') {
                return value !== null && value !== undefined && value !== '';
            }

            let i = caseSensitive ? '' : 'i';

            switch (condition) {
                case 'Contains':
                    return new RegExp(input.replace(/\?/g, '.'), i).test(value);
                case 'Equals':
                    return new RegExp(`^${input.replace(/\?/g, '.')}$`, i).test(value);
                case 'Starts with':
                    return new RegExp(`^${input.replace(/\?/g, '.')}`, i).test(value);
                default:
                    return false;
            }
        },
        onScroll($event) {
            var elem = $event.target;
            if (elem.scrollHeight - elem.scrollTop < .1 * elem.scrollHeight) {
                this.shownTagsLength += 50;
            }
        },
        zoomToTag(element) {
            if (this.viewer) {
                isolateForge(this.viewer, this.viewer.model, [element.children[0].dbId])
                this.$store.dispatch('updateSelectedNode', { nodeId: element.children[0].dbId })

                if (this.selectedHarvesterNode) {
                    this.selectedHarvesterNode.isSelected = false;
                    this.$store.commit('SET_HARVESTER_NODE', null);
                }
            }
        },
        updateTags() {
            this.adminAppContainer.open3dViewerIfNot();

            this.clearFilter();

            this.scrollToTop();

            this.tagsToCreate = []
            this.invalidIdsCount = 0

            if (!this.viewer || !this.viewer.model || !this.viewer.model.getInstanceTree()) return;

            this.tagHarvester.filterOptions = this.tagHarvester.filterOptions.filter(o => !!o.category && !!o.property && !!o.condition);

            this.progressText = "Loading objects, please wait..."
            this.showProgress = true;

            const instanceTree = this.viewer.model.getInstanceTree();
            var rootId = instanceTree.getRootId();
            let level = this.treeLevels.indexOf(this.tagHarvester.selectedTreeLevel);

            let children = this.getNodesAtDepth(rootId, instanceTree, level) ?? [];
            
            this.updateIgnoredNode()
            .then(() => {
                this.validateIgnoredNodes(children)
                .then(this.validateNodesProperties)
                .then(this.validateDuplicatedNodes)
                .then(this.getValidNodesNames)
                .then(validNodes => {
                    console.log(`✅ Valid Nodes: ${validNodes.length}`);
    
                    this.validNodes = validNodes;
                    this.updateTagsNames();
    
                    // Update Ignored Tags
                    if (this.tagHarvester.markIgnore) {
                        let ignoredTags = this.$store.getters['GET_IGNORED_TAGS_IDS'];
                        let tagsDbIds = this.validNodes.length ? this.validNodes.map(n => n.dbId) : [];
                        this.$store.commit('SET_MUTABLE_IGNORED_TAGS_IDS', [...ignoredTags, ...tagsDbIds]);
                        console.log(`✅ Ignored Tags: ${this.$store.getters.GET_MUTABLE_IGNORED_TAGS_IDS.length}`);
                    }
    
                    // Update Shown Tags
                    this.shownTagsLength = 50;
                    this.showProgress = false;
                });
            });
        },
        updateIgnoredNode() {
            return new Promise((resolve, reject) => {
                let ignoredIds = this.$store.getters['GET_MUTABLE_IGNORED_TAGS_IDS'];

                HttpService.post({
                    url: 'api/equipments/updateIgnoredDbIds',
                    data: {
                        assetId: this.$store.state.assetId,
                        ignoredDbIds: ignoredIds.join(',')
                    },
                }).then(() => {
                    this.$store.commit('SET_IGNORED_TAGS_IDS', ignoredIds);
                    resolve();
                }).catch(reject)
            })
        },
        scrollToTop() {
            let scrollable = document.getElementById('harvester_scrollable');
            if (scrollable) scrollable.scrollTop = 0;
        },
        getValidNodesNames(nodesIds) {
            return new Promise(resolve => {

                console.log('🔎 Get Valid Nodes Names');

                let GetMatchingValue = (properties, name) => {
                    if (this.matchingCategory && this.matchingProperty) {
                        return properties.find(p => p.displayCategory == this.matchingCategory && p.displayName == this.matchingProperty)?.displayValue ?? "";
                    }

                    return name;
                }

                const instanceTree = this.viewer.model.getInstanceTree();
    
                let promises = [];
                let data = [];

                console.time('getProperties')

                let options = {
                    propFilter: this.matchingProperty ? [this.matchingProperty] : 'Name',
                    categoryFilter: this.matchingCategory ? [this.matchingCategory] : [],
                };

                this.viewer.model.getBulkProperties(nodesIds, options, result => {
                    
                    for (let i = 0; i < result.length; i++) {

                        let { dbId, properties } = result[i];

                        let name = instanceTree.getNodeName(dbId);

                        data.push({
                            dbId: dbId,
                            name: name,
                            originalName: name,
                            matchingValue: properties[0].displayValue,
                        });

                    }
                    
                    data.sort((a, b) => a.name.localeCompare(b.name));
                    
                    resolve(data);
                });

            });
        },
        validateNodesProperties(children) {
            return new Promise(resolve => {
                console.log('🔎 Validate Nodes')
                
                if (this.tagHarvester.filterOptions?.length == 0) {
                    resolve(children);
                    return;
                }

                const optionsByOperation = groupBy(this.tagHarvester.filterOptions, 'operation');
                const optionsOr = optionsByOperation['Or'] ?? [];
                const optionsAnd = optionsByOperation['And'] ?? [];
                const optionsNot = optionsByOperation['Not'] ?? [];

                let validNodes = [];

                let properties = this.tagHarvester.filterOptions.reduce((result, current) => {
                    if (result.includes(current.property)) return result;
                    result.push(current.property);
                    return result;
                }, []);
                
                this.viewer.model.getBulkProperties(children, properties, result => {
                    for (let i = 0; i < result.length; i++) {
                        let { dbId, properties } = result[i];

                        let isValid = this.isPropertiesHaveValidValue(properties, optionsOr, optionsAnd, optionsNot);

                        if (isValid) validNodes.push(dbId);
                    }
                    
                    resolve(validNodes);
                })
            })
        },
        validateIgnoredNodes(nodes) {
            return this.$store.dispatch('VALIDATE_IGNORED_NODE_IDS', { nodesIds: nodes });
        },
        validateDuplicatedNodes(nodes) {
            return this.$store.dispatch('VALIDATE_DUPLICATED_NODE_IDS', { nodesIds: nodes }).then(validNodesIds => {
                this.invalidIdsCount = nodes.length - validNodesIds.length;
                return validNodesIds;
            });
        },
        isPropertiesHaveValidValue(properties, optionsOr, optionsAnd, optionsNot) {
            for (let i = 0; i < optionsNot.length; i++) {
                const statement = optionsNot[i];

                let property = properties.find(p =>  p.displayName == statement.property && p.displayCategory == statement.category);

                if (!property?.displayValue) return false;

                let isValid =  this.isValidValue(statement.condition, property.displayValue, statement.value, statement.caseSensitive);

                if (isValid) return false;
            }

            if (!optionsOr.length && !optionsAnd.length) return true;

            for (let i = 0; i < optionsOr.length; i++) {
                const statement = optionsOr[i];

                let property = properties.find(p =>  p.displayName == statement.property && p.displayCategory == statement.category);

                if (!property?.displayValue) continue;

                let isValid =  this.isValidValue(statement.condition, property.displayValue, statement.value, statement.caseSensitive);

                if (isValid) return isValid;
            }

            for (let i = 0; i < optionsAnd.length; i++) {
                const statement = optionsAnd[i];

                let property = properties.find(p =>  p.displayName == statement.property && p.displayCategory == statement.category);

                if (!property?.displayValue) return false;

                let isValid =  this.isValidValue(statement.condition, property.displayValue, statement.value, statement.caseSensitive);

                if (!isValid) return false;

                if (i == optionsAnd.length - 1) return true;
            }

            return false;
        },
        getAllAutomaticTagsDbids(callback){
            this.showProgress = true;
            this.$store.dispatch('fetchAllAutomaticTagsDbids', {
                assetId: this.$store.state.assetId, callback: () => {
                    this.showProgress = false;
                    if (callback) callback();
                }
            });
        },
        dbidsToAutomaticTags(dbIds) {
            const instanceTree = this.viewer.model.getInstanceTree();
            var result = [];
            dbIds.forEach(dbId => {
                let tag = new ForgeEquipment();
                tag.originalName = instanceTree.getNodeName(dbId);
                tag.name = tag.originalName;
                tag.id = dbId;
                result.push(tag);
            });

            return result
        },
        updateTagsNames(){
            this.shownTagsList.forEach(o=>{
                if(this.removeSlash && o.originalName.startsWith('/') )
                    o.name = o.originalName.slice(1,o.originalName.length)
                else
                    o.name = o.originalName
            })
        },
        onCloseClicked() {
            console.log('🎯 Close Clicked')

            if(this.showProgress) return;

            this.validNodes = [];
            this.validNodesIds = [];
            this.shownTagsList = [];
            this.$store.commit('SET_HARVESTER_CATEGORIES', ['available-tag', 'filtered-tag', 'created-tag', 'ignored-tag']);
            this.$store.commit('SET_HARVESTER_NODE', null);
            this.$store.dispatch('RESET_HARVESTER_INFO');
            this.tagsToCreate = [];
            this.$store.state.showAddAutoTagsPopup = false;
            this.showTagMasterResult = false;
            this.progressText = '';
            this.invalidIdsCount = 0;
        },
        generate() {
            // if (!this.shownTagsList.length && this.disabledIgnoreButton) {
            //     this.$store.dispatch({ type: "alert_Forge", message: 'No result found, please change the options.' });
            //     return false;
            // }

            if (!this.tagHarvester.title) {
                this.$store.dispatch({ type: "alert_Forge", message: 'Please add a Type.' });
                return false;
            }

            if (!this.tagHarvester.masterType) {
                this.$store.dispatch({ type: "alert_Forge", message: 'Please select the Master.' });
                return false;
            }

            if (!this.isMasterAvailable) {
                this.$store.dispatch({ type: "alert_Forge", message: 'Please update the Master table.' });
                return false;
            }

            this.showTagMasterResult = true;
        },
        generate2() {
            if (!this.shownTagsList.length && this.disabledIgnoreButton) {
                this.$store.dispatch({ type: "alert_Forge", message: 'No equipments found, please change the options first to find equipments.' })
                return false;
            }

            if (!this.tagHarvester.title) {
                this.$store.dispatch({ type: "alert_Forge", message: 'Please add a title.' })
                return false;
            }

            this.progressText = `Updating Ignored Nodes`
            this.showProgress = true;

            let ignoredIds = this.$store.getters['GET_MUTABLE_IGNORED_TAGS_IDS'];

            HttpService.post({
                url: 'api/equipments/updateIgnoredDbIds',
                data: {
                    assetId: this.$store.state.assetId,
                    ignoredDbIds: ignoredIds.join(',')
                },
            }).then(() => {
                this.$store.commit('SET_IGNORED_TAGS_IDS', ignoredIds);

                if (this.tagHarvester.markIgnore || this.validNodes.length === 0) {
                    this.showProgress = false;
                    this.onCloseClicked();
                    return;
                }

                this.showProgress = true;
                const batchSize = 1000;
                const validNodes = this.validNodes;

                // Start with an empty resolved promise
                let chain = Promise.resolve();

                for (let i = 0; i < validNodes.length; i += batchSize) {
                    const batch = validNodes.slice(i, i + batchSize);
                    chain = chain.then(() => {
                        this.progressText = `Uploading ${i + batch.length} / ${validNodes.length} Equipments, please wait...`;
                        return this.createAutomaticEquipmentsBatch(batch);
                    });
                }

                // Wait for the entire chain to complete
                return chain;
            }).then(() => {
                // Perform additional logic after all requests are done
                this.$store.dispatch('fetchAllAutomaticTagsDbids', { assetId: this.$store.state.assetId });
                this.$store.dispatch('FETCH_ADMIN_AUTOMATIC_TAGS', { assetId: this.$store.state.assetId });
                this.showProgress = false;
                this.onCloseClicked();
            }).catch(error => {
                // Handle errors
                console.error(error);
                this.showProgress = false;
                this.$store.dispatch({ type: "alert_Forge", message: error.response?.data?.message || "An error occurred" });
            });

        },
        createAutomaticEquipmentsBatch(batch) {
            return HttpService.post({
                url: 'api/equipments/createAutomaticEquipments',
                data: {
                    assetId: this.$store.state.assetId,
                    harvester: {
                        id: this.tagHarvester.id,
                        title: this.tagHarvester.title,
                        masterType: this.tagHarvester.masterType,
                        forgeAssetId: this.$store.state.assetId,
                        metaData: JSON.stringify({
                            filterOptions: this.tagHarvester.filterOptions,
                            selectedTreeLevel: this.tagHarvester.selectedTreeLevel,
                            removeSlash: this.tagHarvester.removeSlash,
                            matchingCategory: this.matchingCategory,
                            matchingProperty: this.matchingProperty,
                        })
                    },
                    tags: batch.map(({ dbId, name }) => {
                        let tag = new ForgeEquipment();

                        tag.id = 0;
                        tag.createdOn = new Date();
                        tag.createdBy = this.$store.state.username;
                        tag.createdById = this.$store.state.userId;

                        tag.name = name;
                        tag.point = this.forgeService.view3dToWorld(getMiddleBBoxForGroup([dbId]).getCenter());
                        tag.children = [];

                        var elem = new ForgeObject();
                        elem.dbId = dbId;
                        elem.center = this.forgeService.view3dToWorld(getBBBox([dbId], this.viewer.model).getCenter());
                        elem.name = tag.name;
                        tag.children.push(elem);

                        return tag;
                    })
                },
            }).then(response => {
                // Extract harvesterId from the first response
                if (this.tagHarvester.id == null && response.data && response.data.tagHarvester) {
                    this.tagHarvester.id = response.data.tagHarvester.id;
                }

                return response;
            });
        },
        debounceSearch(val) {
			this.maxSearchLimit = 50;
			this.currentSearchText = val
		},
        clearFilter() {
            this.maxSearchLimit = 50;
			this.searchInput = ""
			this.currentSearchText = ""
        },
        toggleCategory(category) {
            let c = this.selectedCategories;

            if (c.includes(category)) {
                c = c.filter(a => a != category);
            } else {
                c.push(category);
            }

            this.selectedCategories = c;
        }
    },
    watch: {
        "showAddAutoTagsPopup": {
            handler:
                function (isShown) {
                    $('.left-content').css('overflow-y', isShown ? 'hidden' : 'auto')
                    if(isShown) {
                        document.getElementsByClassName('left-content').item(0).scrollTop = 0
                        this.initializeComponent();
                        this.getAllAutomaticTagsDbids(() => {
                            this.adminAppContainer.open3dViewerIfNot();
                        });
                    }
                },
            deep: true
        },
        isGeometryLoaded: {
            handler:
                function (loaded) {
                    if (loaded) {
                        this.initializeComponent();
                    } else {
                        this.onCloseClicked();
                    }
                },
            deep: true
        },
        "isViewerLoaded": {
            handler:
                function (loaded) {
                    if (loaded) {
                        this.initializeComponent();
                    } else {
                        this.onCloseClicked();
                    }
                },
            deep: true
        },
        "selectedHarvesterNodeId": {
            handler: function (nodeId) {
                if (!nodeId) return; 

                let index = this.validNodes.findIndex(t => t.dbId == nodeId);

                isolateForge(this.viewer, this.viewer.model, [nodeId])

                let t = this.validNodes[index];
                
                this.maxSearchLimit = 50;
                this.searchInput = t.name
                this.currentSearchText = t.name

                setTimeout(() => {
                    const element = document.getElementById(`equipment-${nodeId}`);
                    scrollToElementInContainer(element, ".scrollable-content");
                }, 100)
            },
            deep: true
        },
        "shownNodesIds": {
            handler: function (dbIds) {
                if (!this.viewer?.model) return;
                let instanceTree = this.viewer.model.getInstanceTree();
                if (!instanceTree) return;
                this.shownTagsList = dbIds.map(dbId => {
                    let tag = new ForgeEquipment();
                    tag.originalName = instanceTree.getNodeName(dbId);
                    tag.name = tag.originalName;
                    tag.point = this.forgeService.view3dToWorld(getMiddleBBoxForGroup([dbId]).getCenter());
                    tag.id = dbId;
                    tag.children = [];

                    var elem = new ForgeObject();
                    elem.dbId = dbId;
                    elem.center = this.forgeService.view3dToWorld(getBBBox([dbId], this.viewer.model).getCenter());
                    elem.name = tag.name;

                    tag.children.push(elem);

                    return tag;
                })
            },
            deep: true
        },
        matchingCategory: {
            handler: function (category) {
                let properties = this.propertiesByCategory[category] ?? [];

                this.matchingProperty = properties.length ? properties[0] : "";
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
        tagHarvester() {
            return this.$store.getters['GET_TAG_HARVESTER_INFO']
        },
        isReadOnly () {
            return !!this.tagHarvester.id
        },
        propertiesByCategory() {
            return this.$store.getters['getAllPropertiesByCategory']
        },
        showAddAutoTagsPopup() {
            return this.$store.state.showAddAutoTagsPopup;
        },
        isViewerLoaded(){
            return this.$store.getters['getIsTreeLoaded']
        },
        sortedTags() {
            return [...this.tagsToCreate].sort((a, b) => a.name.localeCompare(b.name));
        },
        filteredTags() {
            return this.sortedTags.filter(t => t.name.toLowerCase().includes(this.currentSearchText.toLowerCase()))
        },
        shownTags(){
            return this.tagHarvester.markIgnore ? [] : (this.filteredTags.slice(this.shownTagsStartIndex, this.shownTagsLength) ?? []);
        },
        modelElementsObject: {
			set (value) { 
				this.$store.commit("setModelElementsObject", value);
			},
			get () {

				return this.$store.getters['getModelElementsObject']
			}
		},
        selectedHarvesterNode () {
            return this.$store.getters['GET_HARVESTER_NODE'];
        },
        selectedHarvesterNodeId () {
            return this.selectedHarvesterNode?.nodeId;
        },
        isMasterAvailable() {
            switch (this.tagHarvester.masterType) {
                case 'Equipment Master':
                    return this.$store.getters.GET_IS_EQUIPMENT_MASTER_AVAILABLE;
                case 'Pipeline Master':
                    return this.$store.getters.GET_IS_PIPELINE_MASTER_AVAILABLE;
                case 'Structural Master':
                    return this.$store.getters.GET_IS_STRUCTURAL_MASTER_AVAILABLE;
                default:
                    return false;
            }
        },
        input: {
			get() {
				return this.searchInput;
			},
			set(val) {
				this.searchInput = val;

				if (this.timeout) clearTimeout(this.timeout);

				this.timeout = setTimeout(() => {
					this.debounceSearch(val);
				}, 500);
			},
		},
        selectedCategories: {
            get() {
                return this.$store.getters['GET_HARVESTER_CATEGORIES'];
            },
            set(value) {
                this.$store.commit('SET_HARVESTER_CATEGORIES', value)
            }
        },
        validOptions () {
            return this.tagHarvester.filterOptions.filter(o => !!o.category && !!o.property && !!o.condition && (o.condition == 'Is Not Empty'|| !!o.value));
        },
        disabledIgnoreButton () {
            return JSON.stringify(this.$store.getters['GET_MUTABLE_IGNORED_TAGS_IDS']) == JSON.stringify(this.$store.getters['GET_IGNORED_TAGS_IDS'])
        },
        searchDisabled() {
            return false;
        },
        generateDisabled() {
            return !this.tagHarvester.masterType || !this.tagHarvester.title || this.validOptions.length != this.tagHarvester.filterOptions.length;
        },
        forgeService: {
            get() {
                return this.$store.state.forgeService;
            }
        },
        adminAppContainer: {
            get() {
                return this.$store.state.adminAppContainer;
            }
        },
        viewer: {
            get() {
                return this.$store.state.viewer;
            }
        },
        isGeometryLoaded: {
            get() {
                return this.$store.state.isGeometryLoaded;
            }
        },
        searchLower() {
            return this.currentSearchText.toLowerCase();
        },
        filteredNodes() {
            return this.searchLower ? this.validNodes.filter(t => t.name.toLowerCase().includes(this.searchLower)) : this.validNodes;
        },
        validNodesLength: {
            get() {
                return this.validNodes.length
            }
        },
        validNodes: {
            get() {
                return this.$store.getters.GET_HARVESTER_VALID_NODE
            },
            set(value) {
                this.$store.commit('SET_HARVESTER_VALID_NODE', value)
            }
        },
        shownNodesIds: {
            get() {
                return this.filteredNodes.slice(this.shownTagsStartIndex, this.shownTagsLength).map(n => n.dbId) ?? [];
            }
        },
        showTagMasterResult: {
            get() {
                return this.$store.getters.GET_SHOW_TAG_MASTER_RESULT;
            },
            set(value) {
                this.$store.commit('SET_SHOW_TAG_MASTER_RESULT', value);
            }
        },
        matchingCategory: {
            get() {
                return this.tagHarvester.matchingCategory;
            },
            set(value) {
                this.tagHarvester.matchingCategory = value;
            }
        },
        matchingProperty: {
            get() {
                return this.tagHarvester.matchingProperty;
            },
            set(value) {
                this.tagHarvester.matchingProperty = value;
            }
        },
    },
    mounted() {
        this.shownTagsList = [];
    },
}
</script>

<style>
#addAutoTagsModal {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(1, 1, 1, .5);
}
#addAutoTagsModal .modal-content {
    width: 40vw;
    max-width: 810px;
    padding: 15px;
}
#addAutoTagsModal .row-input {
    padding-left: 0px;
}
#addAutoTagsModal select, #addAutoTagsModal .option-row input {
    height: 30px;
    padding-left: 5px;
    font-size: 12px;
    width: 100%;
}
#addAutoTagsModal .option-row {
    display: flex;
    margin-top: 5px;
    column-gap: 5px;
}
#addAutoTagsModal .option-row div {
    display: flex;
    flex-direction: column;
}
#addAutoTagsModal .option-row .option-action {
    display: flex;
    flex-direction: column;
    justify-content: end;
    row-gap: 5px;
    width: 12.5px;
}
#addAutoTagsModal .option-row span {
    font-size: 12px;
    margin-bottom: 3px;
}
#addAutoTagsModal .option-row .option-action i{
    color: var(--primary-color);
    cursor: pointer;
    font-size: 12px;
}

#addAutoTagsModal .option-row .option-action i:hover{
    color: var(--dark-primary-color);
}
#addAutoTagsModal .scrollable-content {
    padding: 0;
    height: 275px;
    margin-bottom: 10px;
}
#addAutoTagsModal .scrollable-content .card-row {
    margin: 0 5px 5px 0px;
    min-height: 85px;
}
.add-option-button {
    color: var(--primary-color);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 20px;
    width: 12.5px;
}
.add-option-button:hover {
    color: var(--dark-primary-color);
}

.property-column {
    width: 30%;
}

.none-tags {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

#addAutoTagsModal .search-input-bar {
    align-items: center;
    padding: 0px 5px;
    margin-right: 5px
}

#addAutoTagsModal .search-input-bar .search-icon{
    padding-top: 0px;
}

#addAutoTagsModal .search-input-bar input{
    height: 30px;
}

#addAutoTagsModal .search-input-bar .cursor-pointer,
#addAutoTagsModal .search-input-bar .fas.fa-search {
    color: var(--light-primary-color);
}

#addAutoTagsModal .search-input-bar .cursor-pointer:hover {
    color: var(--primary-color);
}

#addAutoTagsModal .filters-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 5px;    
}

#addAutoTagsModal .filters-buttons button {
    all: unset;
    opacity: 0.5;
}

#addAutoTagsModal .filters-buttons button.filter-button {
    width: 25px;
    height: 25px;
    background: yellow;
    cursor: pointer;
    border: 1px solid var(--light-primary-color);
    border-radius: 5px;
    background: url(../../../images/filtered-tag.png);
    background-size: cover;
}

#addAutoTagsModal .filters-buttons button.filter-button.ignored-tag-image {
    background: url(../../../images/ignored-tag.png);
    background-size: cover;
}
#addAutoTagsModal .filters-buttons button.filter-button.created-tag-image {
    background: url(../../../images/created-tag.png);
    background-size: cover;
}
#addAutoTagsModal .filters-buttons button.filter-button.available-tag-image {
    background: url(../../../images/available-tag.png);
    background-size: cover;
}
#addAutoTagsModal .filters-buttons button.filter-button.filtered-tag-image {
    background: url(../../../images/filtered-tag.png);
    background-size: cover;
}

#addAutoTagsModal .filters-buttons button.filter-button:hover,
#addAutoTagsModal .filters-buttons button.filter-button.selected-category {
    border-color: var(--primary-color);
    box-shadow: inset 0 0 20px 0px #b4849f26;
    opacity: 1;
}

#addAutoTagsModal .rounded-btn {
    padding: 0 15px;
    border: solid 1px var(--light-primary-color);
    height: 30px;
    border-radius: 15px;
    color: #ad5087;
    font-size: 12px;
    background: white;
    cursor: pointer;
    transition: 0.2s;
    letter-spacing: 0.5px;
}
#addAutoTagsModal .rounded-btn:not(:disabled):hover {
    border-color: #f2f2f2;
    color: white;
    background: var(--primary-color);
}
#addAutoTagsModal .rounded-btn:disabled {
    color: #b9b9b9 !important;
    background: #f2f2f2;
    border-color: #b9b9b9;
}

.tag-harvester-main-info-section {
    display: flex;
    column-gap: 5px;
}

.tag-harvester-main-info-section .tiers-options {
    display: flex;
    justify-content: center;
    align-items: center;
}

.options-title {
    font-size: 12px;
    margin: 5px 0 0 0;
}

.spinning-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.spinning-container .spinning {
    font-size: 60px;
    color: var(--primary-color);
}

.input-with-icon {
    border: 1px solid var(--primary-color);
    display: flex;
    flex-direction: row !important;
    justify-content: flex-start;
    align-items: center;
    border-radius: 5px;
    box-sizing: border-box;
}

.input-with-icon input {
    border: none;
    height: 28px!important;
}

.input-with-icon i {
    padding: 0 10px;
    color: var(--primary-color);
    cursor: pointer;
}

.input-with-icon i:hover {
    color: var(--dark-primary-color);
}

#addAutoTagsModal .result-options,
#addAutoTagsModal .harvester-result-text {
    font-size: 12px;
}

.harvester-input-title {
    font-size: 12px;
    margin-bottom: 5px;
    display: flex;
}

#addAutoTagsModal .harvester-search-section .admin-btn {
    margin: 0;
}

#addAutoTagsModal .harvester-search-section {
    align-items: flex-end;
}

.harvester-search-section input[type="checkbox" i] {
    margin: 0px 3px;
}

.matching-property-container {
    display: flex;
    width: 68%;
    gap: 10px;
}

.matching-property-container > div {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 12px;
}

.matching-property-container input:disabled {
    height: 30px !important;
}
</style>
